import { render, staticRenderFns } from "./IconMonoClient.vue?vue&type=template&id=af0f3bbe&"
import script from "./IconMonoClient.vue?vue&type=script&lang=ts&"
export * from "./IconMonoClient.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports